import { render } from "./ProductGrid.vue?vue&type=template&id=af90cb9c&scoped=true"
import script from "./ProductGrid.vue?vue&type=script&lang=js"
export * from "./ProductGrid.vue?vue&type=script&lang=js"

import "./ProductGrid.vue?vue&type=style&index=0&id=af90cb9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af90cb9c"]])

export default __exports__